import React, {
  useState, useCallback, useRef, useEffect,
} from 'react';
import { getHomeCategories } from '$/domains/caseV3/caseV3Service';
import { V3CanvasHomeCaseItem, V3CanvasHomeCategoryItem } from '$/domains/caseV3/type';
import { useLanguageStore } from '$/store/languageStore';
import FeaturedCaseList from '../FeaturedCaseList';
import styles from './index.module.scss';

interface Props {
  onCardClick?: (item: V3CanvasHomeCaseItem) => void;
  onTryButtonClick?: (item: V3CanvasHomeCaseItem) => void;
  onLoaded?: () => void;
}

/**
 * 渲染首页推荐案例区，并在接口完成后通知父级恢复页面滚动位置。
 */
function FeaturedCaseSection({ onCardClick, onTryButtonClick, onLoaded }: Props) {
  const [categories, setCategories] = useState<V3CanvasHomeCategoryItem[]>([]);
  const [loading, setLoading] = useState(false);
  const loadedRef = useRef(false);
  const mountedRef = useRef(true);
  const sentinelRef = useRef<HTMLDivElement>(null);
  const languageStore = useLanguageStore((state) => state.languageStore);

  /**
   * 拉取首页案例分类，完成后触发父级布局恢复逻辑。
   */
  const loadCategories = useCallback(async () => {
    if (loading || loadedRef.current) return;
    setLoading(true);
    try {
      const data = await getHomeCategories({ type: 'workflow', preview_count: 20, scene: 'case' });
      const list = data.list || [];
      if (!mountedRef.current) return;
      if (list.length > 0) {
        setCategories(list);
      }
    } finally {
      if (mountedRef.current) {
        loadedRef.current = true;
        setLoading(false);
        onLoaded?.();
      }
    }
  }, [loading, onLoaded]);

  useEffect(() => {
    loadCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  return (
    <div className={styles.section}>
      {categories.map((category) => (
        <FeaturedCaseList
          key={category.category_id}
          list={category.cases}
          groupId={category.category_id}
          groupName={category.name}
          groupDesc={category.desc}
          onCardClick={onCardClick}
          onTryButtonClick={onTryButtonClick}
        />
      ))}
      <div ref={sentinelRef} className={styles.sentinel}>
        {loading && <span className={styles.loadingText}>{languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_loading1)}</span>}
      </div>
    </div>
  );
}

export default React.memo(FeaturedCaseSection);
